import { BannerId } from './banners';
import { PageStatus } from './common';

export interface SmartCenterInfo {
    size: {
        w: number;
        h: number;
    };
    pos: {
        x: number;
        y: number;
    };
}

export interface ImageSmartCenterEditorData {
    bannerId: BannerId;
    imageUrl: string;
    selectedId: SMART_CENTER_RATIOS;
    centers: Partial<Record<SMART_CENTER_RATIOS, SmartCenterInfo>>;
    sortOrder: Array<SMART_CENTER_RATIOS>;
    imageSize: {
        height: number;
        width: number;
    };
    formatId: string;
    imageHash: string;
    status: PageStatus;
    error?: string;
}

export enum SMART_CENTER_RATIOS {
    ONE_BY_ONE = '1:1',
    THREE_BY_FOUR = '3:4',
    FOUR_BY_THREE = '4:3',
    SIXTEEN_BY_FIVE = '16:5',
    SIXTEEN_BY_NINE = '16:9'
}

export const SMART_CENTER_RATIOS_ORDER: Array<SMART_CENTER_RATIOS> = [
    SMART_CENTER_RATIOS.ONE_BY_ONE,
    SMART_CENTER_RATIOS.THREE_BY_FOUR,
    SMART_CENTER_RATIOS.FOUR_BY_THREE,
    SMART_CENTER_RATIOS.SIXTEEN_BY_FIVE,
    SMART_CENTER_RATIOS.SIXTEEN_BY_NINE
];

export interface ImageSmartCenterEditorState {
    data?: ImageSmartCenterEditorData;
    imageHeight?: number;
    imageUrl?: string;
}
